import Vue from 'vue';

function initialState() {
  return {
    ConfigSettings: [],
    showEditModal: false,
    configModalType: '',
    CurrentConfigDetails: {},
    ConfigItemsLoading: false,
    showDeleteModal: false,
    CurrentFilterCategory: {}
  }
}

const state = initialState();

const actions = {
  loadAllSystemConfigData: function (context, filter) {

    context.commit('updateConfigLoading', true);
    return new Promise((resolve, reject) => {
      Vue.http.get('configuration/systemconfiguration?categoryId=' + filter).then(function (data) {
        context.commit('updateConfigLoading', false);
        context.commit('updateCongigSettings', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        context.commit('updateConfigLoading', false);
        reject(error)
      });
    });
  },
  saveSystemConfig: function (context, settings) {
    if (settings == null)
      reject(error);
    return new Promise((resolve, reject) => {
      Vue.http.post('configuration/savesystemconfiguration', settings).then(function (data) {
        if (data != null && data.data.Data != null && !(context.state.CurrentFilterCategory && context.state.CurrentFilterCategory != data.data.Data.Category))
          context.commit('updateConfigList', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  deletSystemConfig: function (context, configInfo) {

    return new Promise((resolve, reject) => {
      Vue.http.delete('configuration/delete/' + configInfo.Id).then(function (data) {
        if (data != null && data.data.Data != null)
          context.commit('deleteConfigFromList', configInfo);
        resolve(data);
      }).catch((error) => {
        reject(error)
      });
    });
  }



};

const mutations = {
  updateCongigSettings: function (state, data) {
    state.ConfigSettings = data;
  },
  toggleEditConfigModal: function (state, data) {
    state.showEditModal = data;
  },
  updateConfigList: function (state, data) {
    if (!state.ConfigSettings)
      state.ConfigSettings = [];
    let index = state.ConfigSettings.findIndex(x => x.Id == data.Id);
    if (index >= 0)
      state.ConfigSettings.splice(index, 1, data);
    else
      state.ConfigSettings.push(data);
  },
  deleteConfigFromList: function (state, config) {
    if (!state.ConfigSettings)
      return;
    let index = state.ConfigSettings.findIndex(x => x.Id == config.Id);
    if (index >= 0)
      state.ConfigSettings.splice(index, 1);
  },
  updateConfigModalType: function (state, data) {
    state.configModalType = data;
  },
  updateCurrentConfigSettings: function (state, data) {
    state.CurrentConfigDetails = data;
  },
  updateConfigLoading: function (state, data) {
    state.ConfigItemsLoading = data;
  },
  toggleDeleteConfigModal: function (state, data) {
    state.showDeleteModal = data;
  },
  updateCurrentFilterCategory: function (state, data) {
    state.CurrentFilterCategory = data;
  }

};

const getters = {
  ConfigSettings: function () {
    return state.ConfigSettings;
  },
  showEditModal: function () {
    return state.showEditModal;
  },
  configModalType: function () {
    return state.configModalType;
  },
  CurrentConfigDetails: function () {
    return state.CurrentConfigDetails;
  },
  ConfigItemsLoading: function () {
    return state.ConfigItemsLoading;
  },
  showDeleteModal: function () {
    return state.showDeleteModal;
  },
  CurrentFilterCategory: function () {
    return state.CurrentFilterCategory;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/SystemConfiguration.js